import type { GovernedSource } from "../../services/api";

interface SourceSelectProps {
  sources: GovernedSource[] | null;
  value: string;
  disabled?: boolean;
  onChange: (contextId: string) => void;
}

/** The semantic model a canvas asks about. Pair with `useQueryableSources`. */
export function SourceSelect({ sources, value, disabled = false, onChange }: SourceSelectProps) {
  return (
    <label className="canvas-field">
      <span>Semantic model</span>
      <select
        value={value}
        disabled={disabled || !sources?.length}
        onChange={(event) => onChange(event.target.value)}
      >
        {sources === null && <option value="">Loading…</option>}
        {sources?.length === 0 && <option value="">None available</option>}
        {sources?.map((item) => (
          <option key={item.id} value={item.id}>
            {item.name}
          </option>
        ))}
      </select>
    </label>
  );
}
